/** Shared, deterministic geometry for the hero network mesh (static poster + animation). */
export const MESH_W = 100;
export const MESH_H = 60;

export type MeshNode = { x: number; y: number; vx: number; vy: number; r: number };

/** Small seeded PRNG so server and client render identical static nodes. */
function mulberry32(seed: number) {
  return () => {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function makeMeshNodes(count: number, seed = 20120): MeshNode[] {
  const rand = mulberry32(seed);
  return Array.from({ length: count }).map(() => ({
    x: rand() * MESH_W,
    y: rand() * MESH_H,
    vx: (rand() - 0.5) * 0.04,
    vy: (rand() - 0.5) * 0.04,
    r: 0.18 + rand() * 0.22,
  }));
}

export function meshLinks(nodes: MeshNode[], linkDistance: number) {
  const links: Array<{ x1: number; y1: number; x2: number; y2: number; o: number }> = [];
  for (let i = 0; i < nodes.length; i++) {
    for (let j = i + 1; j < nodes.length; j++) {
      const a = nodes[i];
      const b = nodes[j];
      const d = Math.hypot(a.x - b.x, a.y - b.y);
      if (d < linkDistance) links.push({ x1: a.x, y1: a.y, x2: b.x, y2: b.y, o: 1 - d / linkDistance });
    }
  }
  return links;
}
